var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('passport-clients'),_c('passport-authorized-clients'),_c('passport-personal-access-tokens')],1)}
var staticRenderFns = []

export { render, staticRenderFns }